import api from './api';

export const analyticsService = {
  getDashboard: (params = {}) => api.get('/analytics/dashboard', { params }),
  getFinanceChart: (period = 'month') => api.get('/analytics/chart/finances', { params: { period } }),
};
